import {
  agentConstants,
  globalConstants,
  initialPagination,
} from "../../constants";

const { GET_AGENT_LISTING, PROPERTY_PAGINATION } = agentConstants;
const { SUCCESS } = globalConstants;

const initialState = {
  propertyList: [],
  propertyPagination: initialPagination,
};

export const agentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AGENT_LISTING + SUCCESS:
      return {
        ...state,
        propertyList: action.data,
      };
    case PROPERTY_PAGINATION:
      return {
        ...state,
        propertyPagination: action.data,
      };

    default:
      return state;
  }
};
